export const TrustRouteSegmentsEnum = {
  Start: 'start',
  Dashboard: 'dashboard',
  TrustDetails: 'trust-details',
  Home: 'home',
  Subscribers: 'subscribers',
  TrustAssets: 'trust-assets',
  BondSurety: 'bond-surety',
  Taxes: 'taxes',
  Forms: 'forms',
  Documents: 'documents',
  Notes: 'notes',
  Messages: 'messages',
  AssetsDetails: 'assets',
  Invitation: 'invitation',
  TrustInformation: 'trust-information',
  Account: 'account',
} as const;

export type TrustRouteSegments =
  (typeof TrustRouteSegmentsEnum)[keyof typeof TrustRouteSegmentsEnum];
